import { useCallback, useContext } from 'react'
import { AxiosContext } from '../context/request.context'

export const useStatistics = () => {
  const { authRequest } = useContext(AxiosContext)


  const getUserPositions = useCallback(async (data) => {

    return await authRequest({
      method: 'POST',
      url: `c-position-stages/getUserPositions`,
      data
    })

  }, [authRequest])

  const getStat = useCallback(async (data) => {
    return await authRequest({
      method: 'POST',
      url: `c-position-stages/getStatistics`,
      data
    })
  }, [authRequest])

  const getExcelFile = useCallback(async (data) => {
    return await authRequest({
      method: 'POST',
      url: `c-position-stages/getExcelFile`,
      data,
      responseType: 'blob'
    })
  }, [authRequest])

    const getExcelManagerFile = useCallback(async (data) => {
    return await authRequest({
      method: 'POST',
      url: `orders/getExcelFile`,
      data,
      responseType: 'blob'
    })
  }, [authRequest])

  const preparePayload = useCallback((rawPayload) => {
    const requestReadyPayload = {
      dateFrom: rawPayload.dateFrom.val,
      dateTo: rawPayload.dateTo.val,
      stages: rawPayload['stage.id'] ? rawPayload['stage.id'].val.map(st => st.id) : [],
      users: rawPayload['user.id'] ? rawPayload['user.id'].val.map(us => us.id) : [],
    }

    if(rawPayload['position.drawings.groupCode']) {
      requestReadyPayload.drawings = rawPayload['position.drawings.groupCode'].val.map(dr => dr.code)
    }

    return requestReadyPayload
  }, [])

  return {
    getStat,
    preparePayload,
    getUserPositions,
    getExcelFile,
    getExcelManagerFile
  }

}